import { getGeoCountries } from "../../../../../../../../../shared/api/catalogs";

interface GetCountriesParams {
	buyer_id: number;
	customer_id: string;
}

export const fetchGeoCountries = async (params: GetCountriesParams) => {
	const data = await getGeoCountries(params);
	return data;
};
